// Define Action Types
const LOG_IN = "LOGIN";
const LOG_OUT = "LOGOUT";
const UPDATE_USER = "UPDATE_USER";

// Define Action Creators
export const logIn = (token, user) => ({
  type: LOG_IN,
  payload: {
    token,
    user,
  },
});

export const logOut = () => ({
  type: LOG_OUT,
});

export const updateUser = (user) => ({
  type: UPDATE_USER,
  payload: {
    user: user,
  },
});

// Define The Reducer
export default (state, action) => {
  switch (action.type) {
    case LOG_IN:
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("token", JSON.stringify(action.payload.token));
      return {
        ...state,
        isLogedIn: true,
        user: action.payload.user,
        token: action.payload.token,
      };

    case LOG_OUT:
      localStorage.clear();
      return {
        ...state,
        isLogedIn: false,
        user: null,
      };

    case UPDATE_USER:
      localStorage.removeItem("user");
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      return {
        ...state,
        user: action.payload.user,
      };
    default:
      return state;
  }
};
